import React from "react"
import { GetStaticProps } from "next"
import { getAllProducts, ProductsColorsItem } from "../../lib/contentful/product/getAllProducts"
import { Entry } from "contentful"
import { TypeProductEntitySkeleton } from "../../lib/contentful/ContentfulVzdelanibudoucnostiTypes"
import { Layout } from "../../components/Layout/Layout"
import { SinglePage } from "../../components/SinglePage/SinglePage"
import { Section } from "../../components/Section"
import { CoursesList } from "../../components/CoursesList/CoursesList"
import { Typography } from "antd"

const EshopIndex: React.FC<Props> = ({ products, productsColors }) => {
  return (
    <Layout>
      <SinglePage title="E-shop">
        <Section>
          <Typography.Title level={2}>Podpořte budoucnost vzdělávání</Typography.Title>
          <Typography.Paragraph>
            Nakupováním v našem e-shopu přispíváte k rozvoji a zlepšování neziskové organizace Vzdelani budoucnosti. Pomáháte nám přinášet inovativní IT kurzy a
            projekty pro děti a mládež, díky kterým se učí tvořit a rozvíjet své dovednosti v oblasti programování a moderních technologií. Vaše podpora nám
            umožňuje neustále posouvat hranice vzdělávání a tvořit lepší budoucnost.
          </Typography.Paragraph>

          <CoursesList courses={products} productsColors={productsColors} />
        </Section>
      </SinglePage>
    </Layout>
  )
}

export default EshopIndex

interface Props {
  products: Entry<TypeProductEntitySkeleton, undefined, string>[]
  productsColors: ProductsColorsItem[]
}

export const getStaticProps: GetStaticProps<any> = async () => {
  const contentfulProducts = await getAllProducts({ "fields.subType[match]": "product" })

  return {
    props: {
      products: contentfulProducts?.products.items ?? [],
      productsColors: contentfulProducts?.productsColors ?? []
    },
    revalidate: process.env.NODE_ENV !== "production" ? 10 : 60
  }
}
